import { useQuery, } from "react-query";
import DataService from '../../../config/DataServices'

const { getRequest } = DataService()

export const useGetNotification = ({ page, size, searchText,
}) => {

    return useQuery({
        queryKey: ["notifi-list", page, size, searchText,
        ],
        queryFn: () => {
            return getRequest(`/admin-notify?page=${page}&size=${size}&search=${searchText}
                `)
        }
    })
}

export const useGetAllNotify = ({ page, size, status,
    searchText,
}) => {

    return useQuery({
        queryKey: ["notifi-lists", page, size, status,
            searchText],
        queryFn: () => {
            return getRequest(`/admin-notifications?page=${page}&size=${size}&status=${status}&search=${searchText}`)
        }
    })
}


